import { number, object } from 'yup'

const inflationOptions = []
let i = 1
while (i <= 3) {
  inflationOptions.push({
    label: `${i} %`,
    value: i,
  })
  i++
}

export const formFields = {
  age: {
    label: 'What is your current age?',
    type: 'text',
  },
  retirementAge: {
    label: 'At what age do you plan to retire?',
    type: 'text',
  },
  afterTaxIncome: {
    label: 'What amount do you earn after-tax on a yearly basis?',
    type: 'text',
    class: 'Currency',
  },
  inflation: {
    label: 'What do you expect inflation to be?',
    type: 'select',
    options: inflationOptions,
  },
}

export const formSchema = object().shape({
  age: number().typeError('must be a number').required('this is required'),
  retirementAge: number()
    .typeError('must be a number')
    .required('this is required')
    .test(
      'older',
      'retirement age must be after current age',
      (value, context) => {
        return value > context.parent.age
      },
    ),
  afterTaxIncome: number()
    .typeError('must be a number')
    .required('this is required'),
  inflation: number().required('this is required'),
})
